module.exports = __webpack_public_path__ + "img/pokeBattle.53515436.jpg";